//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponTip from '@/components/cardCoupons/component/couponTip'
import couponSwiper from '@/components/cardCoupons/component/couponSwiper'
import couponDownload from '@/components/cardCoupons/component/couponDownload'
import wxConfig from '@/assets/js/wx_config'

export default {
  name: "deskDiaryDiscountCoupons",
  components:{
    couponTip,
    couponSwiper,
    couponDownload
  },
  data(){
    return{
        couponId:this.$route.query.couponId,
        coupon:new Array(),
        swiperFlag:false,
        downloadImg:require("../../assets/images/download_in@2x.png"),
        downloadFlag:false,
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    this.$store.commit('UPDATE_PAGE_TITLE','台历3折券');
    document.title = '台历3折券'
    this.getCoupon()
  },
  methods:{
    getCoupon(){
        let self = this;
        this.baseAjax({
            url:'/coupon/get',
            showLoading:true,
            type:'post',
            data:{
                "couponId":self.couponId
            },
            success:function (data) {
                self.coupon = data.coupon
                console.log(data)
                self.getBase64(data.coupon.shareImageUrl)
                self.getSharedInfo()
            }
        })
    },
    getSharedInfo(){
      let self = this;
      this.baseAjax({
        url:'/h5/getCard',
        showLoading:false,
        type:'post',
        data:{
            "type":"share_coupon",
            "returnType":"card",
            "couponId":self.couponId,
            "shareKey":self.coupon.shareCardKey
        },
        success:function (data) {
            console.log(data)
            if(wxConfig.isWeiXin()){
                let title = data.card.title
                let desc = data.card.desc
                let linkUrl = data.card.link
                let imgUrl = data.card.imgUrl
                wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
            }
        }
      })
    },
    getBase64(imgUrl){
      console.log(imgUrl)
      const img = new Image();
      img.src = imgUrl;
      img.onload = () => {
        this.swiperFlag = true
      }
    },
    download(){
      this.$router.push(`/homePortal/invite_in`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/cardCoupons/deskDiaryDiscountCoupons.vue